export const ALL_ELD_KT = "ALL_ELD_KT";
export const ELD_KT_TEST = "ELD_KT_TEST";
export const ELD_KT_DRIVERS = "ELD_KT_DRIVERS";
export const ELD_KT_VEHICLES = "ELD_KT_VEHICLES";
